import type { Account, AccountApiResponse } from '../types/Account';

type ApiError = Error & { status: number };

function getApiBaseUrl(): string {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

  if (!apiBaseUrl) {
    throw new Error('VITE_API_BASE_URL is not configured');
  }

  return apiBaseUrl;
}

export async function authFetch(
  url: string,
  accessToken: string,
): Promise<Response> {
  return fetch(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });
}

export async function getAccounts(accessToken: string): Promise<Account[]> {
  const apiBaseUrl = getApiBaseUrl();
  const response = await authFetch(
    `${apiBaseUrl}/list-accounts`,
    accessToken,
  );

  if (!response.ok) {
    const error = new Error('API request failed') as ApiError;
    error.status = response.status;
    throw error;
  }

  const data: AccountApiResponse[] = await response.json();

  return data
    .map((item) => ({
      name: item.name,
      appLink: item.links.appLink,
    }))
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
}
